import React from 'react'
import './Filter.css'

function Filter({genre , setGenre, language, setLanguage}) {


  return (
    <div className='filter-container'>
        <div className="heading"> <i className='fa-solid fa-filter'></i> 
        &nbsp;Filters</div>

        <div className="language">
            <div className="head">
                <span>Languages</span>
                <span className='clearFilter' onClick={()=>{setLanguage("")}}> <i className='fa-solid fa-broom'></i> Clear</span>
            </div>
            <div className="flexlang">
                <div className="langPills" style={(language === "Hindi") ? {backgroundColor : "#f58181", color : "#fff"} :{backgroundColor : "transparent"}} onClick={()=>{setLanguage("Hindi")}} >Hindi</div>
                <div className="langPills" style={(language === "English") ? {backgroundColor : "#f58181", color : "#fff"} :{backgroundColor : "transparent"}} onClick={()=>{setLanguage("English")}} >English</div>
            </div>
        </div>

        <div className='genreSelect'>
        <div className="head">
                <span>Genre</span>
                <span className='clearFilter' onClick={()=>{setGenre("")}}> <i className='fa-solid fa-broom'></i> Clear</span>
            </div>
            <select value={genre} style={{border : genre && "solid 2px #f58181", color : genre && "#f58181"}} name="genre" id="genre" onChange={(e)=>{setGenre(e.target.value)}} >
                <option value="">None</option>
                <option value="Action">Action</option>
                <option value="Thriller">Thriller</option>
                <option value="Sci-Fi">Sci-Fi</option>
                <option value="Romantic">Romantic</option>
                <option value="Drama">Drama</option>
                <option value="Comedy">Comedy</option>
                <option value="Family">Family</option>
                <option value="Adventure">Adventure</option>
                <option value="Sports">Sports</option>
                <option value="Biopic">BioPic</option>
            </select>
        </div>
    </div>
  )
}

export default Filter
